import React, { useRef, useEffect } from "react";
import { motion } from "framer-motion";
import { RiCloseLine } from "react-icons/ri";
import { SearchIcon } from "../page/assets";
import PropTypes from "prop-types";

const recommended = ["Earbuds", "Shipping", "Speakers", "Accessories"];

const SearchOverlay = ({ onClose }) => {
  const inputRef = useRef(null);

  useEffect(() => {
    inputRef.current?.focus();
    const onKey = (e) => e.key === "Escape" && onClose();
    window.addEventListener("keydown", onKey);
    return () => window.removeEventListener("keydown", onKey);
  }, [onClose]);

  return (
    <motion.div
      initial={{ y: "-100%", opacity: 0 }}
      animate={{ y: 0, opacity: 1 }}
      exit={{ y: "-100%", opacity: 0 }}
      transition={{ duration: 0.5, ease: [0.22, 1, 0.36, 1] }}
      className="fixed inset-0 z-50 max-h-[800px] flex justify-start max-w-[1440px] mx-auto overflow-clip"
    >
      {/* Opaque Background with Blur */}
      <motion.div
        initial={{ y: "-100%", opacity: 0 }}
        animate={{ y: 0, opacity: 1 }}
        exit={{ y: "-100%", opacity: 0 }}
        transition={{ duration: 0.6, ease: [0.22, 1, 0.36, 1] }}
        className="absolute inset-0 h-full bg-black/70 max-md:hidden"
        onClick={onClose}
      />
      <div className="max-w-lg md:max-w-md w-full h-full bg-white absolute right-0 top-0  max-md:backdrop-blur-md">
        {/* Top search bar row */}
        <div className="flex items-center px-8 md:px-16 h-[100px] gap-4">
          {/* <SearchIcon className="w-5 h-5 text-black shrink-0 opacity-40" /> */}
          <input
            ref={inputRef}
            type="text"
            placeholder="Search for anything..."
            className="flex-1 bg-transparent text-[16px] font-light text-black placeholder-[#9ca3af] outline-none tracking-[0.32px] font-['Helvetica_Neue',sans-serif]"
          />
          <div className="flex flex-row-reverse gap-4 items-center">
            <motion.button
              whileHover={{ scale: 1.1 }}
              whileTap={{ scale: 0.9 }}
              onClick={onClose}
              className="shrink-0"
            >
              <RiCloseLine className="w-6 h-6 text-black" />
            </motion.button>
            <motion.button
              whileHover={{ scale: 1.1 }}
              whileTap={{ scale: 0.9 }}
              className="shrink-0"
            >
              <SearchIcon className="w-6 h-6 text-black" />
            </motion.button>
          </div>
        </div>

        {/* Divider */}
        <div className="h-px bg-[#e5e5e5] w-full" />

        {/* Recommended section */}
        <div className="px-8 md:px-16 pt-8 pb-12 space-y-5">
          <p className="text-[11px] font-mono uppercase tracking-[0.8px] text-[#9ca3af]">
            Recommended
          </p>
          <ul className="flex flex-col gap-5">
            {recommended.map((term) => (
              <motion.li
                key={term}
                whileHover={{ x: 4 }}
                transition={{ type: "spring", stiffness: 400, damping: 25 }}
              >
                <button
                  className="text-[16px] font-light text-black tracking-[0.32px] font-['Helvetica_Neue',sans-serif] text-left"
                  onClick={onClose}
                >
                  {term}
                </button>
              </motion.li>
            ))}
          </ul>
        </div>
      </div>
    </motion.div>
  );
};

SearchOverlay.propTypes = {
  onClose: PropTypes.func.isRequired,
};

export default SearchOverlay;
